import { useState } from 'react';

// graphql
import { CashTransferStatus, PageInfo, useApt_PlayerBalanceWithdrawalsQuery } from '@/generated/graphql';

// interfaces
import {
  IPlayerWithdrawalTransactionTable,
  IPlayerBalanceWithdrawal,
  IPlayerBalanceWithdrawalQueryVariable,
  mapGQLPlayerBalanceWithdrawal,
} from '@/shared/interfaces';

// helpers
import { formatNumber } from '@/shared/constants';

// components
import { TablePlayerBalanceWithdrawals } from './table';

export const PlayerWithdrawals = () => {
  const [withdrawals, setWithdrawals] = useState<IPlayerWithdrawalTransactionTable[]>([]);

  const [queryVariable, setQueryVariable] = useState<IPlayerBalanceWithdrawalQueryVariable>({
    first: 25,
    filterBy: {
      status: [CashTransferStatus.VirifiedByAuditor, CashTransferStatus.VirifiedByCashier, CashTransferStatus.Confirmed],
    },
  });
  const [withdrawalPageInfo, setWithdrawalPageInfo] = useState<PageInfo>();
  const [withdrawalTotalCount, setWithdrawalTotalCount] = useState<number>(0);

  const playerBalanceWithdrawalQuery = useApt_PlayerBalanceWithdrawalsQuery({
    notifyOnNetworkStatusChange: true,
    variables: queryVariable,
    onCompleted(data) {
      const mapPlayerBalanceWithdrawals: IPlayerBalanceWithdrawal[] = data.playerBalanceWithdrawals.nodes.map((playerBalanceWithdrawal) =>
        mapGQLPlayerBalanceWithdrawal(playerBalanceWithdrawal),
      );

      setTimeout(() => {
        setWithdrawals(
          mapPlayerBalanceWithdrawals.map((x) => ({
            id: x.id,
            amountDisplay: formatNumber(x.amount),
            referenceId: x.referenceId,
            transactionType: x.transactionType,
            createdAt: x.createdAt,
            status: x.status,
            receiverAccountNumber: x.receiverAccountNumber,
            senderAccountNumber: x.senderAccountNumber,

            playerName: `${x.player.firstName} ${x.player.lastName}`,
            auditorName: `${x.auditor.firstName} ${x.auditor.lastName}`,
          })),
        );
        setWithdrawalPageInfo(data.playerBalanceWithdrawals.pageInfo);
        setWithdrawalTotalCount(data.playerBalanceWithdrawals.totalCount);
      }, 100);
    },
  });

  return (
    <>
      <TablePlayerBalanceWithdrawals
        rows={withdrawals}
        setPlayerBalanceWithdrawalQueryVariable={setQueryVariable}
        playerBalanceWithdrawalQueryVariable={queryVariable}
        totalCount={withdrawalTotalCount}
        pageInfo={withdrawalPageInfo}
        getPlayerBalanceWithdrawalLoading={playerBalanceWithdrawalQuery.loading}
      />
    </>
  );
};
